export default {
  translation: {
    hello: 'Hello World',
  },
};
